import * as React from 'react';
import classnames from 'classnames';
import { prefixClassName } from 'framework/components/ui/_conf';
import { Button, Icon, Text } from 'framework/components/ui';
import { IMessageProps } from './MessagePrimitve.interface';
import './_style.scss';

const clx = prefixClassName('message-primitive');

enum labels {
  info = 'components.message.labels.info',
  success = 'components.message.labels.success',
  note = 'components.message.labels.note',
  warning = 'components.message.labels.warning',
  error = 'components.message.labels.error',
  notification = 'components.message.labels.notification',
}

const MessagePrimitive = (props: IMessageProps) => {
  const {
    caption,
    visible = true,
    className,
    type = 'info',
    onClose = null,
    showLabel = true,
    customLabel,
    ctaButton = null,
  } = props;

  if (!caption) return null;

  return (
    <div className={classnames(clx, `${clx}--${type}`, !visible && 'mwg-hidden', className)}>
      {showLabel && <Text caption={customLabel || labels[type]} tag="strong" />}
      <span className={`${clx}__content`}>{caption}</span>
      {ctaButton && <Button className={`${clx}__cta`} {...ctaButton} />}
      {onClose && <Icon className={`${clx}__closeIcon`} name="close" onClick={onClose} />}
    </div>
  );
};

export default MessagePrimitive;
